import {
  CartItemType,
  isTrackCartItem,
  isAlbumCartItem,
  getCartItemId,
  useCartManager,
} from "@/components/providers/CartProvider";
import { splitLicenseType } from "@/lib/licensing-utils";
import { Flex, Text } from "@radix-ui/themes";
import TrackArtwork from "@/components/ui/TrackArtwork";

type CartItemProps = {
  data: CartItemType;
};

export default function CartItem({ data }: CartItemProps) {
  const { removeFromCart } = useCartManager();

  if (isTrackCartItem(data)) {
    return (
      <Flex
        data-testid="cart-item"
        className="border-b-[1px] pt-[13px] pb-[13px] items-center"
      >
        <div className="shrink-0 w-[56px] h-[56px]">
          <TrackArtwork
            type={data.track.type}
            src={
              data.track.imageUrl! || "/placeholders/album_art_placeholder.png"
            }
            alt={data.track.title!}
            className="w-full h-full border-[1px] rounded-[10px] shadow-md object-cover"
          />
        </div>
        <Flex className="flex-1 pl-[15px] flex-col w-full">
          <Flex className="w-full mb-[3px]">
            <Text className="font-bold flex-1 line-clamp-1 pr-[15px]">
              {data.track.title}
            </Text>
            <Text className="font-bold">${data.price.toFixed(2)}</Text>
          </Flex>
          <Text className="font-semibold text-[12px] text-text-secondary">
            {data?.track?.creator?.stageName}
          </Text>
          <Text className="font-semibold mt-[3px] text-[12px] text-text-secondary">
            {splitLicenseType(data.licenseType).join(", ")}
          </Text>
          <Text
            data-testid="cart-item-remove"
            onClick={() => removeFromCart(getCartItemId(data))}
            className="font-bold mt-[10px] text-[13px] cursor-pointer hover:text-red-600"
          >
            Remove
          </Text>
        </Flex>
      </Flex>
    );
  }

  if (isAlbumCartItem(data)) {
    return (
      <Flex
        data-testid="cart-item"
        className="border-b-[1px] pt-[13px] pb-[13px] items-center"
      >
        <img
          src={
            data.album.artworkUrl || "/placeholders/album_art_placeholder.png"
          }
          alt={data.album.title}
          className="shrink-0 w-[56px] h-[56px] border-[1px] rounded-[10px] shadow-md object-cover"
        />
        <Flex className="flex-1 pl-[15px] flex-col w-full">
          <Flex className="w-full mb-[3px]">
            <Text className="font-bold flex-1 line-clamp-1 pr-[15px]">
              {data.album.title}
            </Text>
            <Text className="font-bold">${data.price.toFixed(2)}</Text>
          </Flex>
          <Text className="font-semibold text-[12px] text-text-secondary">
            {data.album.creator?.stageName}
          </Text>
          <Text className="font-semibold mt-[3px] text-[12px] text-text-secondary">
            Album
          </Text>
          <Text
            data-testid="cart-item-remove"
            onClick={() => removeFromCart(getCartItemId(data))}
            className="font-bold mt-[10px] text-[13px] cursor-pointer hover:text-red-600"
          >
            Remove
          </Text>
        </Flex>
      </Flex>
    );
  }

  return null;
}
